import { Action, createReducer, on } from '@ngrx/store';
import { remove } from 'lodash';

import { PremiitError } from '../../utils/premiit-error';
import { Supplier } from '../../pages/suppliers/supplier';
import * as suppliersActions from '../actions/suppliers.actions';

export interface SupplierState {
  data: Supplier[];
  selected: Supplier;
  loading: boolean;
  color: string;
  error: PremiitError;
}

const supplierInitState: SupplierState = {
  data: [],
  selected: null,
  loading: false,
  color: null,
  error: null
};

const _supplierReducer = createReducer(supplierInitState,
  on(suppliersActions.getSuppliersAction, (state: SupplierState) => ({ ...state, loading: true})),
  on(suppliersActions.getSupplierSuccessAction, (state: SupplierState, { suppliers}) => ({
    ...state,
    data: [...suppliers],
    loading: false,
    error: null
  })),
  on(suppliersActions.getSupplierErrorAction, (state: SupplierState, { error}) => ({
    ...state,
    loading: false,
    error
  })),
  on(suppliersActions.selectSupplier, (state: SupplierState, { supplier }) => ({
    ...state,
    selected: { ...supplier },
  })),
  on(suppliersActions.unSelectSupplier, (state: SupplierState) => ({
    ...state,
    selected: null,
  })),
  on(suppliersActions.setColor, (state: SupplierState, { color }) => ({
    ...state,
    color
  })),
  on(suppliersActions.createSupplierAction, (state: SupplierState) => ({
    ...state,
    loading: true,
  })),
  on(suppliersActions.createSupplierSuccessAction, (state: SupplierState, { supplier }) => {
    const suppliers: Supplier[] = [...state.data];
    suppliers.push(supplier);
    return {
      ...state,
      data: suppliers,
      loading: false,
      error: null
    };
  }),
  on(suppliersActions.createSupplierErrorAction, (state: SupplierState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(suppliersActions.updateSupplierAction, (state: SupplierState) => ({ ...state, loading: true })),
  on(suppliersActions.updateSupplierSuccessAction, (state: SupplierState, { supplier }) => {
    const suppliers = [...state.data];
    suppliers.map((stateSupplier: Supplier) => {
      if (stateSupplier.id === supplier.id) {
        stateSupplier = supplier;
      }
      return stateSupplier;
    });
    return {
      ...state,
      data: suppliers,
      selected: null,
      color: null,
      loading: false
    };
  }),
  on(suppliersActions.updateSupplierErrorAction, (state: SupplierState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(suppliersActions.deleteSupplierAction, (state: SupplierState) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(suppliersActions.deleteSupplierSuccessAction, (state: SupplierState, { supplier }) => {
    const suppliers = [...state.data];
    remove(suppliers, (item: Supplier) => (supplier.id === item.id));
    return {
      ...state,
      data: suppliers,
      loading: false,
      error: null,
      selected: null,
      color: null,
    };
  }),
  on(suppliersActions.deleteSupplierError, (state: SupplierState, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function SuppliersReducer(state: SupplierState, action: Action): any {
  return _supplierReducer(state, action);
}
